import procedureUpdateHover from "../../../assets/image/editHover.svg";
import procedureUpdateEntry from "../../../assets/image/edit.svg";
import { shareTaskMassage } from "../../../app/publicDictionaryValues";
import ProcedureDetailService from "../../../service/procedureFile/ProcedureDetailService";
import NormalToolTip from "../toolTip";
import styles from "./index.module.scss";
import { useClickAway, useRequest, useSetState } from "ahooks";
import { message } from "antd";
import procedureListService from "service/procedureList";
import { convertedTasks } from "app/pages/procedureList/utils";
import { wrapRequestToPromise } from "utils/index";
import { useRef } from "react";

const ListUpdateBtnIcon = (props: {
  href: string;
  record: ReturnType<typeof convertedTasks>[number];
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
  className?: string;
  testid?: string;
}) => {
  const [tooltipMessage, setTooltipMessage] = useSetState({
    createBtnHintMsg: "",
    isCreateBtnToolTipOpen: false,
    entrySrc: procedureUpdateEntry,
  });
  const ref = useRef<HTMLAnchorElement>(null);

  const checkProcedureFileEditOnSuccess = (response: any) => {
    if (response.result) {
      window.open(props.href, "_blank");
    } else {
      setTooltipMessage({
        createBtnHintMsg: shareTaskMassage[response.messageCode as keyof typeof shareTaskMassage],
        isCreateBtnToolTipOpen: true,
      });
    }
    props.setLoading(false);
  };

  const checkProcedureFileEditOnError = (error: any) => {
    console.log(error);
    props.setLoading(false);
    message.error("Check Procedure Files Error!");
  };

  const { run: runGetFirstPPO } = useRequest(
    wrapRequestToPromise(procedureListService.getFirstPpo),
    {
      manual: true,
      onBefore: () => {
        props.setLoading(true);
      },
      onSuccess: async (result: Response) => {
        const firstPpo = await result.text();
        if (!firstPpo || firstPpo.trim() === "") {
          setTooltipMessage({
            createBtnHintMsg: shareTaskMassage[2],
            isCreateBtnToolTipOpen: true,
          });
          props.setLoading(false);
        } else {
          setTooltipMessage({ isCreateBtnToolTipOpen: false });
          const param = {
            procedureAccountId: props.record.procedureAccountID,
            procedureId: props.record.procedureId,
            procedureTaskId: props.record.procedureTaskId,
          };
          ProcedureDetailService.checkEditSection(
            param,
            checkProcedureFileEditOnSuccess,
            checkProcedureFileEditOnError
          );
        }
      },
      onError: (error) => {
        console.error(error);
        props.setLoading(false);
        message.error("Check Procedure Files Error!");
      },
    }
  );

  const checkPPO = () => {
    runGetFirstPPO(props.record.procedureId);
  };

  const clearCreateState = () => {
    setTooltipMessage({
      isCreateBtnToolTipOpen: false,
    });
  };

  useClickAway(() => {
    if (!tooltipMessage.isCreateBtnToolTipOpen) return;
    clearCreateState();
  }, ref);

  return (
    <NormalToolTip
      element={
        <div className={`${props.className} ${styles.createBtn}`}>
          <NormalToolTip
            element={
              <a
                ref={ref}
                onClick={checkPPO}
                onBlur={clearCreateState}
                onMouseEnter={() => {
                  setTooltipMessage({ entrySrc: procedureUpdateHover });
                }}
                onMouseLeave={() => {
                  setTooltipMessage({
                    entrySrc: procedureUpdateEntry,
                    isCreateBtnToolTipOpen: false,
                  });
                }}
                target="_blank"
                rel="noopener noreferrer"
                data-testid={props.testid}
              >
                <img alt="" src={tooltipMessage.entrySrc} />
              </a>
            }
            title="Update Procedure"
          />
        </div>
      }
      title={tooltipMessage.createBtnHintMsg}
      trigger="click"
      open={tooltipMessage.isCreateBtnToolTipOpen}
      placement="top"
    />
  );
};
export default ListUpdateBtnIcon;
